import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QSTeamPermissions } from '@app/core/permissions';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { UserCacheService } from '@app/core/services/user-cache/user-cache.service';
import { SsrsLogicService } from '@app/logic/ssrs';
import { TeamsLogicService } from '@app/logic/teams/teams.logic.service';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { IActualCostsDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { forIn } from 'lodash';
import { map, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'cb-lot-costs-actual',
    templateUrl: './lot-costs-actual.component.html',
    styleUrls: ['./lot-costs-actual.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LotCostsActualComponent implements OnDestroy, OnInit {

    private _subscriptions = new Subscription();
    public allExpanded = false;
    public loading = true;
    public actualCosts$: Observable<IActualCostsDto>;
    @Input() private readonly lotId: number;
    public expandedAreas: { [specGroupLabel: string]: boolean | null } = {};
    @Output() public readonly expandedAreasChange = new EventEmitter<{ [specGroupLabel: string]: boolean | null }>();

    constructor(
        private readonly teamsLogicService: TeamsLogicService,
        private readonly logicService: SsrsLogicService,
        private readonly toastService: ToastService,
        private readonly cdRef: ChangeDetectorRef,
        private readonly userCacheService: UserCacheService,
        private readonly route: ActivatedRoute,
        private readonly dialogService: CbDialogService,
        private readonly qsTeamPermissions: QSTeamPermissions,
        private readonly navigationService: NavigationService
    ) {

    }

    public ngOnInit(): void {
        if (!this.loading) {
            this.loading = true;
            this.cdRef.detectChanges();
        }
        this.actualCosts$ = this.logicService.getCostsForLot(this.lotId).pipe(

            map(quantityAccount => {
                quantityAccount?.buildStages.forEach(stage => {
                    this.expandedAreas[stage.label] = false;
                });

                if (this.loading) {
                    this.loading = false;
                    this.cdRef.detectChanges();
                }
                return quantityAccount;
            })
        );

        this._subscriptions.add(
            this.actualCosts$.subscribe()
        );
    }

    public expandCollapseAll(): void {
        this.allExpanded = this.getAllExpanded();
        forIn(this.expandedAreas, (value, key) => {
            this.expandedAreas[key] = !this.allExpanded;
        });
        this.allExpanded = !this.allExpanded;
    }

    public getAllExpanded(): boolean {
        let expandedAreasCount = 0;
        let panelCount = 0;
        forIn(this.expandedAreas, (value, key) => {
            if (value === true) {
                expandedAreasCount++;
            }
            panelCount++;
        });

        if (expandedAreasCount === panelCount) {
            return true;
        } else {
            return false;
        }
    }

    public ngOnDestroy(): void {
        this._subscriptions.unsubscribe();
    }

    public expandedChange(): void {
        this.expandedAreasChange.emit(this.expandedAreas);
    }
}
